'use client';

import React, { useState, useEffect } from 'react';
import Link from 'next/link';
import { useLocale, useTranslations } from 'next-intl';
import { Button } from '@/components/ui/button';

const STORAGE_KEY = 'mypokermetrics-cookie-consent';

export function CookieBanner() {
  const [mounted, setMounted] = useState(false);
  const [accepted, setAccepted] = useState(false);
  const locale = useLocale();
  const t = useTranslations('cookieBanner');

  useEffect(() => {
    setMounted(true);
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored === 'accepted') setAccepted(true);
    } catch {
      setAccepted(true); // pas de localStorage = on n'affiche pas pour éviter boucle
    }
  }, []);

  const handleAccept = () => {
    try {
      localStorage.setItem(STORAGE_KEY, 'accepted');
    } catch {
      // ignore
    }
    setAccepted(true);
  };

  if (!mounted || accepted) return null;

  return (
    <div
      role="dialog"
      aria-label={t('ariaLabel')}
      className="fixed bottom-0 left-0 right-0 z-50 px-4 py-3 sm:px-6 sm:py-4 bg-white dark:bg-gray-900 border-t border-gray-200 dark:border-gray-700 shadow-lg"
    >
      <div className="container mx-auto flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
        <p className="text-sm text-gray-700 dark:text-gray-300">
          {t('message')}{' '}
          <Link
            href={locale === 'fr' ? `/${locale}/confidentialite` : `/${locale}/privacy`}
            className="underline font-medium text-gray-900 dark:text-white hover:no-underline"
          >
            {t('learnMore')}
          </Link>
        </p>
        <Button onClick={handleAccept} size="sm" variant="default" className="shrink-0">
          {t('accept')}
        </Button>
      </div>
    </div>
  );
}
